import { ergoTreeFromAddress } from "../../entities/ergoTree";
export class DefaultTransactions {
    constructor(prover, txAsm) {
        this.prover = prover;
        this.txAsm = txAsm;
    }
    async simple(recipient, ctx) {
        const outputGranted = ctx.inputs.totalOutputWithoutChange;
        const out = {
            value: outputGranted.nErgs - ctx.feeNErgs,
            ergoTree: ergoTreeFromAddress(recipient),
            creationHeight: ctx.network.height,
            assets: outputGranted.assets,
            additionalRegisters: {}
        };
        const req = {
            inputs: ctx.inputs,
            dataInputs: [],
            outputs: [out],
            changeAddress: ctx.changeAddress,
            feeNErgs: ctx.feeNErgs
        };
        return this.prover.sign(this.txAsm.assemble(req, ctx.network));
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidHJhbnNhY3Rpb25zLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vLi4vc3JjL2VyZ28vd2FsbGV0L3NlcnZpY2VzL3RyYW5zYWN0aW9ucy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFLQSxPQUFPLEVBQUMsbUJBQW1CLEVBQUMsTUFBTSx5QkFBeUIsQ0FBQTtBQU0zRCxNQUFNLE9BQU8sbUJBQW1CO0lBQzlCLFlBQTRCLE1BQWMsRUFBa0IsS0FBa0I7UUFBbEQsV0FBTSxHQUFOLE1BQU0sQ0FBUTtRQUFrQixVQUFLLEdBQUwsS0FBSyxDQUFhO0lBQUcsQ0FBQztJQUVsRixLQUFLLENBQUMsTUFBTSxDQUFDLFNBQWtCLEVBQUUsR0FBdUI7UUFDdEQsTUFBTSxhQUFhLEdBQUcsR0FBRyxDQUFDLE1BQU0sQ0FBQyx3QkFBd0IsQ0FBQTtRQUN6RCxNQUFNLEdBQUcsR0FBRztZQUNWLEtBQUssRUFBRSxhQUFhLENBQUMsS0FBSyxHQUFHLEdBQUcsQ0FBQyxRQUFRO1lBQ3pDLFFBQVEsRUFBRSxtQkFBbUIsQ0FBQyxTQUFTLENBQUM7WUFDeEMsY0FBYyxFQUFFLEdBQUcsQ0FBQyxPQUFPLENBQUMsTUFBTTtZQUNsQyxNQUFNLEVBQUUsYUFBYSxDQUFDLE1BQU07WUFDNUIsbUJBQW1CLEVBQUUsRUFBRTtTQUN4QixDQUFBO1FBQ0QsTUFBTSxHQUFHLEdBQUc7WUFDVixNQUFNLEVBQUUsR0FBRyxDQUFDLE1BQU07WUFDbEIsVUFBVSxFQUFFLEVBQUU7WUFDZCxPQUFPLEVBQUUsQ0FBQyxHQUFHLENBQUM7WUFDZCxhQUFhLEVBQUUsR0FBRyxDQUFDLGFBQWE7WUFDaEMsUUFBUSxFQUFFLEdBQUcsQ0FBQyxRQUFRO1NBQ3ZCLENBQUE7UUFDRCxPQUFPLElBQUksQ0FBQyxNQUFNLENBQUMsSUFBSSxDQUFDLElBQUksQ0FBQyxLQUFLLENBQUMsUUFBUSxDQUFDLEdBQUcsRUFBRSxHQUFHLENBQUMsT0FBTyxDQUFDLENBQUMsQ0FBQTtJQUNoRSxDQUFDO0NBQ0YifQ==